import { render } from "./CustomPieceCreator.vue?vue&type=template&id=618b4f1e"
import script from "./CustomPieceCreator.vue?vue&type=script&lang=js"
export * from "./CustomPieceCreator.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__